<template>
  <loader v-if="loadingProducts" />
  <div v-else>
    <h5>{{ i18n.t('/pdf/categories/categories deliverycosts label') }}</h5>
    <products-block
      data-qa="deliverycosts-block"
      :products="products"
      :products-categories="categories"
      :selected-products="selectedProducts"
      :can-add-products="false"
      :products-are-editable="isEditable"
      block-type="DeliveryCosts"
      @add-to-selected="addToSelected"
      @remove-from-selected="removeFromSelected"
    />
  </div>
</template>

<script>
import ProductsBlock from '@/components/generic/presentational/organisms/productsBlock/ProductsBlock.vue'
import HandleAccessoryEvents from '@/mixins/handleAccessoryEvents.js'
import StoreConnector from '@/helpers/StoreConnector'
import Loader from '@/components/generic/presentational/atoms/loader/Loader.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    ProductsBlock,
    Loader,
  },
  mixins: [HandleAccessoryEvents],
  data() {
    return {
      products: [],
      selectedProducts: [],
      viewmodel: null,
      loadingProducts: true,
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      categories: ['DeliveryCosts'],
    }
  },
  computed: {
    ...mapGetters({
      quoteStatusIsSalesOrder: 'quote/quoteStatusIsSalesOrder',
    }),

    isEditable() {
      return !this.quoteStatusIsSalesOrder
    },
  },
  created() {
    StoreConnector.get('accessories/loading', (data) => {
      this.loadingProducts = data
    })

    StoreConnector.getWithParam('quote/accessoriesWithCategories', this.categories, (data) => {
      this.selectedProducts = data
    })

    StoreConnector.getWithParam(
      'accessories/accessoriesWithCategories',
      this.categories,
      (data) => {
        this.products = data
      }
    )
  },
  unmounted() {
    StoreConnector.removeListeners([
      'viewmodels/get',
      'accessories/loading',
      'accessories/accessoriesWithCategories',
      'quote/accessoriesWithCategories',
    ])
  },
}
</script>
